// React Thirty Party Library
import { Drawer, Form, Input, Checkbox, Col, Row } from "antd";
import {
    LockOutlined,
} from '@ant-design/icons';
import { useState, useEffect } from 'react';

// Components Library
import { BtnSubmit, } from "../../../../../../components";

// Handler Library

// Services Library

// Redux Actions

// Styles Library
import "./index.css";

const DrawerViewBankInfo = (props) => {
  const { isOpen, setIsOpen, data } = props;

  const [useEmployeeName, setUseEmployeeName] = useState(false);
  
  const [form] = Form.useForm();

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue({
        ...data,
        bank_acc: "xxxxxxx",
        bank_holderIc: "xxxxxx-xx-xxxx", 
      });
    }
  }, [isOpen]);
  

  useEffect(() => {
    if (useEmployeeName) {
      const employeeName = form.getFieldValue("name");
      form.setFieldsValue({ bank_holderName: employeeName });
    } else {
      form.setFieldsValue({ bank_holderName: "" });
    }
  }, [useEmployeeName, form]);

  const ActionButton = (
    <Form.Item style={{ paddingTop: '20px' }}>
      <div>
        <BtnSubmit
          display='inline-block'
          text='Close'
          bgColor='#0E2483'
          color='white'
          padding='9px 18px'
          onClick={() => {
            form.resetFields();
            setIsOpen(false);
          }}
        />
        <BtnSubmit
          display='inline-block'
          text='Edit'
          bgColor='transparent'
          color='#C8C8C8'
          padding='9px 18px'
          border='1px solid #C8C8C8'
          onClick={() => {
            // form.resetFields();
            setIsOpen(false);
          }}
        />
      </div>
    </Form.Item>
  );

  return (
    <>
    <Drawer
      title="View Bank Info"
      placement='right'
      closable={false}
      width={410}
      onClose={() => setIsOpen(false)}
      footer={ActionButton}
      open={isOpen}
      style={{
        textAlign: 'center',
        fontSize: '20px',
      }}
    >
      <Form form={form} layout='vertical'>
        <Row>
            <Col className="subtitle">
                <span >Bank information</span>
            </Col>
            
            <Col style={{width: "100%", margin: "10px 0px"}}>
                <label htmlFor="bank_name" className="labelInput">
                    Bank name <span style={{ color: 'red' }}>*</span>
                </label>
                <Form.Item
                name="bank_name"
                rules={[
                    {
                    required: true,
                    message: "Bank name is required",
                    },
                ]}
                >
                  <Input readOnly className="inputForm" style={{ backgroundColor: 'transparent', color:"black !important" }} suffix={<LockOutlined style={{ color: '#D9D9D9' }} />} />
                </Form.Item>
            </Col>
            
            <Col style={{width: "100%"}}>
                <label htmlFor="bank_acc" className="labelInput">
                    Bank account <span style={{ color: 'red' }}>*</span>
                </label>
                <Form.Item
                name="bank_acc"
                rules={[
                    {
                    required: true,
                    message: "Bank account is required",
                    },
                ]}
                >
                  <Input readOnly className="inputForm" style={{ backgroundColor: 'transparent', color:"black !important" }} suffix={<LockOutlined style={{ color: '#D9D9D9' }} />} />
                </Form.Item>
            </Col>

            <Col className="checkbox">
                <Checkbox
                    checked={useEmployeeName}
                    onChange={(e) => setUseEmployeeName(e.target.checked)}
                    disabled
                >
                    Use employee name
                </Checkbox>
            </Col>

            <Col style={{width: "100%", marginTop: "20px"}}>
                <label htmlFor="bank_holderName" className="labelInput">
                    Bank holder name <span style={{ color: 'red' }}>*</span>
                </label>
                <Form.Item
                name="bank_holderName"
                rules={[
                    {
                    required: true,
                    message: "Bank holder name is required",
                    },
                ]}
                >
                  <Input readOnly className="inputForm" style={{ backgroundColor: 'transparent', color:"black !important" }} suffix={<LockOutlined style={{ color: '#D9D9D9' }} />} />
                </Form.Item>
            </Col>

            <Col style={{width: "100%", marginTop: "10px"}}>
                <label htmlFor="bank_holderIc" className="labelInput">
                    Bank holder IC  <span style={{ color: 'red' }}>*</span>
                </label>
                <Form.Item
                name="bank_holderIc"
                rules={[
                    {
                    required: true,
                    message: "Bank holder IC is required",
                    },
                ]}
                >
                  <Input readOnly className="inputForm" style={{ backgroundColor: 'transparent', color:"black !important" }} suffix={<LockOutlined style={{ color: '#D9D9D9' }} />} />
                </Form.Item>
            </Col>
        </Row>
      </Form>
    </Drawer>
    </>
  );
};

export default DrawerViewBankInfo;
